export default {
    AddingAnInternalReturnRefundDoc: {
        Associate: 'Related sales order',
        Select: 'Select related sales order',
        Basic: 'Basic Information',
        Return: 'Return order type',
        type: 'Return type',
        Tripartite: 'Third-party return Order No.',
        Third: 'Third-party return time',
        reason: 'Return reason',
        stage: 'Return stage',
        Customer: 'Customer service remarks',
        Financial: 'Financial information',
        Settlement: 'Settlement method',
        Logistics: 'Logistics Information',
        Receiving: 'Receiving warehouse',
        information: 'Return logistics information',
        selectcompany: 'Please select a logistics company',
        enterexpress: 'Please enter the express number',
        Product: 'Product Information',
        Add: 'Add returned products',
        Picture: 'Image attachment',
        Selectsales: 'Select related sales order',
        Selectproduct: 'Select products for return and refund',
        Associated: 'Related sales order:',
        Other: 'Other',
        Quantity: 'Quantity already shipped:',
        Returned: 'Quantity already returned:',
        Returnable: 'Quantity available for return:',
        Shipment: 'Shipping status:',
        Preemption: 'Reservation status:',
        Sourcing: 'Sourcing status:',
        Please: 'Please select return order type',
        selecttype: 'Please select return type',
        enterparty: 'Please enter the third-party return Order No.',
        selecttime: 'Please select the third-party return time',
        selectreason: 'Please select the return reason',
        selectstage: 'Please select the return stage',
        selectmethod: 'Please select the settlement method',
        selectwarehouse: 'Please select receiving warehouse',
        selectstatus: 'Please select warehouse receiving status',
        Delete: 'Delete',
        form: {
            Giveaway: 'Whether it is a gift',
            Product: 'Number of Item Lines',
            Returnable: 'Quantity available for return',
            Return: 'Quantity to be returned',
            Refund: 'Unit price of refund',
            Total: 'Total refund amount',
        },
        info: {
            selectsales: 'Please select a related sales order first',
            add: 'Please add returnable products first',
            Please: 'Please enter the return logistics number',
            The: 'Return logistics number cannot be duplicated',
            Deletion: 'Deletion successful',
            returnable: 'The returnable quantity is 0',
            returned: 'The returned data is empty, please contact the administrator',
        },
    }
};
